/** MI DOMINO - UI feed: log lines, lobby + chat surfaces.
 *  Leaf DOM helpers (no game logic). Extracted from legacy.
 *  (banner() stays in legacy for now — it is runtime-decorated with the
 *  gallery/fiesta reactions, which still call back into legacy.) */

/** getElementById with a non-null assertion — these shells always exist. */
const el = (id: string): HTMLElement => document.getElementById(id)!;

export function log(msg: string, big?: boolean): void {
  const box = el('log');
  const p = document.createElement('p');
  if (big) p.className = 'big';
  p.textContent = msg;
  box.prepend(p);
  while (box.children.length > 40) box.removeChild(box.lastChild!);
}

export function hideLobby(): void {
  el('lobby-bg').classList.remove('show');
}

export function addChat(name: string, msg: string, mine: boolean): void {
  const box = el('chat-msgs');
  const p = document.createElement('p');
  p.className = 'chat-m' + (mine ? ' mine' : '');
  // a message that is only emoji (up to a few) reads as a reaction → bigger
  if (msg.length <= 24 && /^[\p{Extended_Pictographic}\p{Emoji_Modifier}️‍\s]+$/u.test(msg)) p.classList.add('emoji-only');
  const b = document.createElement('b');
  b.textContent = name + ': ';
  p.appendChild(b);
  p.appendChild(document.createTextNode(msg));
  box.appendChild(p);
  while (box.children.length > 60) box.removeChild(box.firstChild!);
  box.scrollTop = box.scrollHeight;
}
